module.exports = __webpack_public_path__ + "static/media/thumb_ㅅㅇㄹ_503x503.17a40a85.jpg";